<template>
  <div class="app flex-row align-items-center animated fadeIn bg-light">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card header-bg-variant="info">
              <div slot="header">
                <h3>ReadyNet Device Managment</h3>
              </div>
              <b-form @submit="submitLogin">
                <!-- <p class="text-muted">Login</p> -->
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input id="email" name="email" type="email" class="form-control" placeholder="email address" v-model="email" v-validate="'required|email'" :state="validateState('email')" />
                  <b-form-invalid-feedback>{{ verrors.first('email') }}</b-form-invalid-feedback>
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input id="password" name="password" type="password" class="form-control" placeholder="password" autocomplete="current-password" v-model="password" v-validate="{ required: true}" :state="validateState('password')" />
                  <b-form-invalid-feedback>{{ verrors.first('email') }}</b-form-invalid-feedback>
                </b-input-group>
                <br>
                <b-row class="justify-content-center">
                  <b-button variant="primary" size="lg" class="btn-pill" v-on:click.prevent="submitLogin">
                    <i class="fa fa-play-circle"></i>&nbsp;Sign In</b-button>
                </b-row>
              </b-form>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VueSweetalert2 from 'vue-sweetalert2'
export default {

  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    submitLogin() {
      this.$validator.validate().then(res => {
        if (res) {
          let email = this.email
          let password = this.password
          this.$store.dispatch('login', { email, password })
            .then(() => {
              //console.log("OKK");
              this.$router.push('#/dashboard')
            })
            .catch(error => {
              this.$swal("Error!", 'Please check your email and/or password', "error")
              //console.log('NOO')
            })

        }
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.verrors.has(ref)
      }
      return null
    }
  }
}
</script>
